/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Bank Portal APIs
 * OpenAPI spec version: 0.1
 */

export type BatchEventPaginatedProperty =
  typeof BatchEventPaginatedProperty[keyof typeof BatchEventPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BatchEventPaginatedProperty = {
  TYPE: 'TYPE',
  SUBMITTED_AT: 'SUBMITTED_AT',
  INGESTED_AT: 'INGESTED_AT',
  OWNER_NAME: 'OWNER_NAME',
  OWNER_TYPE: 'OWNER_TYPE',
  FILE_PRODUCED: 'FILE_PRODUCED',
  FILE_NAME: 'FILE_NAME',
} as const;
